import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

function KPICard({ 
  title, 
  value, 
  icon: Icon, 
  trend, 
  trendLabel, 
  gradient, 
  delay = 0 
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.3 }}
      whileHover={{ y: -4, transition: { duration: 0.2 } }}
      className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-all relative overflow-hidden"
    >
      {/* Gradient accent border */}
      <div className={`absolute top-0 left-0 right-0 h-1 ${gradient || 'bg-gradient-to-r from-blue-500 to-purple-600'}`} />
      
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
            {title}
          </p>
          <p className="text-3xl font-bold text-gray-900 dark:text-white">
            {value}
          </p>
          {trend && (
            <p className={`text-sm mt-2 ${trend > 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
              {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}% {trendLabel}
            </p>
          )}
        </div>
        
        <div className={`p-3 rounded-full ${gradient || 'bg-gradient-to-br from-blue-500 to-purple-600'} bg-opacity-10`}>
          {Icon && <Icon size={24} className="text-blue-600 dark:text-blue-400" />}
        </div>
      </div>
    </motion.div>
  );
}

export default KPICard;
